var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-inline-flex"},[_c('cancel-payment-modal',{attrs:{"disabled":_vm.payment.status == "CANCELED","data-id":_vm.payment.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }